import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const FemaleIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon
    width="13px"
    height="24px"
    viewBox="0 0 13 24"
    fill="none"
    data-testid="female-icon"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28856 2.99997C9.28856 4.65681 7.94541 5.99995 6.28855 5.99995C4.63169 5.99995 3.28854 4.65681 3.28854 2.99997C3.28854 1.34313 4.63169 0 6.28855 0C7.94541 0 9.28856 1.34313 9.28856 2.99997ZM2.78637 7.93452C2.90574 7.50047 3.30041 7.19968 3.75058 7.19968H8.20543C8.63697 7.19968 9.01982 7.4765 9.15506 7.8863L12.4551 17.8862C12.6686 18.5332 12.1867 19.1996 11.5054 19.1996H9.28856V23C9.28856 23.5523 8.84084 24 8.28856 24H4.28854C3.73625 24 3.28854 23.5523 3.28854 23V19.1996H1.00057C0.340321 19.1996 -0.138703 18.571 0.0363687 17.9344L2.78637 7.93452Z"
      fill="currentColor"
    />
  </Icon>
);
